import { removeNullValues } from "./../../pm-converters/utils.js";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
const audioConverter = {
  toPm: {
    types: [Node_Type.AUDIO],
    // @ts-expect-error
    convert: (node) => {
      const { id = "", audioData } = node || {};
      return {
        type: Node_Type.AUDIO,
        attrs: {
          id,
          containerData: audioData?.containerData ?? null,
          audio: audioData?.audio ?? null,
          disableDownload: audioData?.disableDownload ?? null,
          coverImage: audioData?.coverImage ?? null,
          name: audioData?.name ?? null,
          authorName: audioData?.authorName ?? null,
          html: audioData?.html ?? null
        }
      };
    }
  },
  fromPm: {
    types: [Node_Type.AUDIO],
    // @ts-expect-error
    convert: (node) => {
      const attributes = node.attrs || {};
      const { id, ...data } = attributes;
      const { loading, error, ...filteredData } = removeNullValues(data);
      if (loading || error) {
        return void 0;
      }
      const result = {
        type: Node_Type.AUDIO,
        id,
        nodes: [],
        audioData: filteredData
      };
      return result;
    }
  }
};
export {
  audioConverter
};
//# sourceMappingURL=audio-converter.js.map
